import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(app)/(footer)/(legal)/_PageSections/TermsAndCondition.tsx");
